import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as OtherCompany from "../modules/otherCompany";
import {OtherCompanyModuleStoreInterface} from "../types";
import {RouteObject} from "react-router-dom";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const OtherCompanyRouter = ({ isAuthenticated, otherCompanyStore }: {
    isAuthenticated: () => boolean,
    otherCompanyStore:  OtherCompanyModuleStoreInterface
}): RouteObject => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/other_company",
                element: <OtherCompany.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/other_company/:id/edit",
                element: <OtherCompany.Edit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return otherCompanyStore.prepareEditForm({ id: params.id });
                },
            },
            {
                path: "/other_company/add",
                element: <OtherCompany.Add />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async () => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return otherCompanyStore.prepareAddForm({});
                },
            },
            {
                path: "/other_company/:id/view",
                element: <OtherCompany.View />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return otherCompanyStore.view({ id: params.id });
                },
            },
        ]
    }
)